// Glimsy — LashShield product page (sections/glimsy-lash-pdp.liquid)
document.querySelectorAll('.gl[data-gl-pdp]').forEach(root => {
  const main = root.querySelector('[data-main]');
  const thumbs = root.querySelectorAll('[data-thumbs] button');
  thumbs.forEach(b => b.addEventListener('click', () => {
    main.scrollTo({ left: main.clientWidth * +b.dataset.i, behavior: 'smooth' });
  }));
  main && main.addEventListener('scroll', () => {
    const i = Math.round(main.scrollLeft / main.clientWidth);
    thumbs.forEach((b, j) => b.setAttribute('aria-current', j === i));
  }, { passive: true });

  const form = root.querySelector('#gl-form');
  const atc = root.querySelector('[data-atc]');
  const atcPrice = root.querySelector('[data-atc-price]');
  const sPrice = root.querySelector('[data-sticky-price]');
  const sTitle = root.querySelector('[data-sticky-title]');
  const qty = root.querySelector('[data-qty]');
  const packs = root.querySelectorAll('.gl-b');
  const sync = () => {
    const r = form.querySelector('input[name="gl-pack"]:checked');
    if (!r) return;
    packs.forEach(l => l.classList.toggle('on', l.contains(r)));
    qty.value = r.value;
    atcPrice.textContent = sPrice.textContent = r.dataset.price;
    sTitle.textContent = r.dataset.title;
  };
  form.addEventListener('change', e => { if (e.target.name === 'gl-pack') sync(); });

  // Straight to checkout: empty the cart first so packs never stack, then post with return_to=/checkout.
  let busy = false;
  form.addEventListener('submit', e => {
    e.preventDefault();
    if (busy) return;
    busy = true;
    atc.disabled = true;
    fetch('/cart/clear.js', { method: 'POST' }).catch(() => {}).finally(() => form.submit());
  });
  window.addEventListener('pageshow', () => { busy = false; atc.disabled = false; sync(); });

  const sticky = root.querySelector('[data-sticky]');
  new IntersectionObserver(([en]) => sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(atc);
  root.querySelector('[data-sticky-btn]').addEventListener('click', () => form.requestSubmit());
});